import React from "react";
import { Grid2 as Grid } from "@mui/material";
import { Form, Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { ChangePasswordModalProps } from "./types";
import { useChangePasswordForm } from "./controller";

export const ChangePasswordModal = React.memo(({ modalRef }: ChangePasswordModalProps) => {
  const { methods, mutateAsync, isPending } = useChangePasswordForm(modalRef);
  const translate = useTranslate();

  return (
    <Modal
      ref={modalRef}
      title={translate("v1/user_admin.titles.edit_password")}
      methods={methods}
      onConfirm={mutateAsync}
      isPending={isPending}
    >
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <Form.Input
            type="password"
            name="password"
            label={translate("v1/user_admin.fields.password")}
            required
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <Form.Input
            type="password"
            name="confirmPassword"
            label={translate("v1/user_admin.fields.confirm_password")}
            required
          />
        </Grid>
      </Grid>
    </Modal>
  );
});
